import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";
import { ButtonGroup, SearchBox } from "@components";
import { RequisitionListTableColumn } from "./RequisitionListTableColumn";

import { useRequisitionList } from "@hooks/inventory/requisition/useRequisitionList";

import { REQUSITION_STATUS } from "@constants/status.inventory";

import { RequisitionResponseType } from "@type/inventory/requisition";
import { Pagination } from "@type/inventory/pagination";
import { useForm } from "react-hook-form";

import { TablePagination } from "@helpers/tablePagination";

const { APPROVED, PENDING, DRAFT } = REQUSITION_STATUS;

export const RequisitionListTable = () => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const { control } = useForm();

  const { handleQuery, requisitionState } = useRequisitionList();
  const { getData, createSuccess, deleteSuccess } = requisitionState;

  const { data, pagination } = getData || ({} as RequisitionResponseType);
  const { page, total } = pagination || ({} as Pagination);

  const [activeStatus, setActiveStatus] = useState(0);

  const filterButtons = t(
    "INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.ACTION_BUTTONS",
    {
      returnObjects: true,
    },
  ) as string[];

  const btnGroupAction = (index: any) => {
    let statusId = null;
    setActiveStatus(index);

    if (index === 0) {
      statusId = null;
    } else if (index === 1) {
      statusId = APPROVED;
    } else if (index === 2) {
      statusId = PENDING;
    } else if (index === 3) {
      statusId = DRAFT;
    } else {
      statusId = null;
    }
    handleQuery("status", statusId);
  };

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess]);

  return (
    <div className="mt-10">
      <Table
        columns={RequisitionListTableColumn(t) as any}
        rows={data}
        headerExtension={{
          leftComponents: [
            <ButtonGroup
              key="btn-group"
              btnGroupData={filterButtons || []}
              activeState={activeStatus}
              action={btnGroupAction}
            />,
          ],
          rightComponents: [
            <SearchBox
              key="search"
              control={control}
              placeholder={t("INVENTORY_REQUISITION.REQUISITION_LIST.SEARCH")}
              handleQuery={handleQuery}
            />,
          ],
        }}
        // actions={[
        //   {
        //     customIcon: <ViewButton />,
        //     onClick(id) {
        //       navigate(`${id}`);
        //     },
        //   },
        // ]}
        header={{
          title: t("INVENTORY_REQUISITION.REQUISITION_LIST.TABLE_HEADING"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};

export default RequisitionListTable;
